import { createSelector, OutputSelector } from 'reselect'
import { IShipmentsState, Shipments, IParamsState, IShipment } from 'types'
import { IStore } from 'apps/booking/utils/reducers'

const selectShipments = (state: IStore): IShipmentsState => state.shipments

interface SelectShipmentList
  extends OutputSelector<
    IStore,
    {
      shipmentList: Shipments
      isFetching: boolean
      params: IParamsState
      hasNextPage: boolean | null
    },
    (
      res: IShipmentsState
    ) => {
      shipmentList: Shipments
      isFetching: boolean
      params: IParamsState
      hasNextPage: boolean | null
    }
  > {}
interface SelectShipmentDetail
  extends OutputSelector<
    IStore,
    {
      shipmentDetails?: IShipment | null
      loading?: boolean
      error: string | null
    },
    (
      res: IShipmentsState
    ) => {
      shipmentDetails?: IShipment | null
      loading?: boolean
      error: string | null
    }
  > {}

export const shipmentListSelector: SelectShipmentList = createSelector(
  selectShipments,
  ({ hasNextPage, isFetching, params, shipmentList }) => ({
    shipmentList,
    isFetching,
    params,
    hasNextPage,
  })
)

export const shipmentDetailSelector: SelectShipmentDetail = createSelector(
  selectShipments,
  ({ error, loading, shipmentDetails }) => ({
    shipmentDetails,
    loading,
    error,
  })
)
